<template>
  <div class="lg-wrap">
    <div class="lg-card">
      <!-- Painel de marca (logo + imagem) -->
      <div class="lg-brand">
        <div class="lg-brand__glow"></div>
        <div class="lg-brand__content">
          <img class="lg-brand__logo" src="../assets/logoTemplusBranca.png" alt="Templus" />
          <img class="lg-brand__art" :src="require('../assets/hero-igreja.svg')" alt="Igreja e comunidade" />
          <p class="lg-brand__tag">Gestão completa para a sua igreja</p>
        </div>
      </div>

      <!-- Formulário -->
      <div class="lg-form">
        <div class="lg-lock"><v-icon color="#00695C">mdi-lock-outline</v-icon></div>
        <div class="lg-title">Bem-vindo!</div>
        <p class="lg-sub">Acesse o painel da sua igreja.</p>

        <v-form @submit.prevent="signin">
          <label class="lg-label">E-mail</label>
          <v-text-field
            v-model="user.email"
            outlined dense color="#00695C" hide-details="auto"
            name="email" type="email" placeholder="seu@email.com"
            :rules="emailRules" required
            prepend-inner-icon="mdi-email-outline"
            class="mb-4"
          ></v-text-field>

          <label class="lg-label">Senha</label>
          <v-text-field
            v-model="user.password"
            outlined dense color="#00695C" hide-details="auto"
            name="password"
            :rules="passwordRules" required
            prepend-inner-icon="mdi-lock-outline"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            @keydown.enter="signin"
            class="mb-4"
          ></v-text-field>

          <v-btn
            v-if="!usuarioLogado"
            type="submit"
            block large depressed
            color="#00695C" dark
            class="lg-btn"
            :loading="loading"
          >
            <v-icon left>mdi-login-variant</v-icon>Entrar
          </v-btn>
        </v-form>

        <p class="lg-foot">Não tem conta? <router-link to="/criar-conta" class="lg-link">Criar conta</router-link></p>
      </div>
    </div>

    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
    import { userKey, baseApiUrl } from '@/global'
    import Snackbar from '../componentes/snackbar.vue'
    import { mapState } from 'vuex'
    import axios from 'axios'
    export default {
        components: {Snackbar},
        name: 'Auth',
        computed: mapState({
            usuarioLogado: state => state.isMenuVisible,
        }),
        data: function() {
            return {
                loading: false,
                countAccess: '',
                userObj: [],
                show1: false,
                token: "",
                userId: "",
                showSignup: false,
                showAlterPass: false,
                userPemission: "",
                user: {},
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail não é válido'
                ],
                nameRules: [
                    v => !!v || 'Nome é obrigatório'
                ],
                passwordRules: [
                    v => !!v || 'Senha é obrigatório'
                ]
            }
        },

        mounted: function () {
            // Segue o tema escolhido na landing (claro/escuro)
            this.$vuetify.theme.dark = localStorage.getItem('tp-landing-theme') === 'dark'
            if (sessionStorage.getItem('accToken') != null)
                this.$router.push({ path: '/home' })
            if (sessionStorage.getItem('userPermission') != null)
                this.$store.dispatch('Permission')
            if (sessionStorage.getItem('accToken') != null)
                this.$store.dispatch('Logar', this.token)
        },

        methods: {
            async signin() {
                this.loading = true
                if ((this.user.email != null) || (this.user.password != null)) {
                    await axios.post(`${baseApiUrl}Usuarios/login`, this.user)
                    .then(res => {
                        this.token = res.data.id
                        this.userId = res.data.userId
                        this.VerficiaAdmin()
                    })
                    .catch(() => {
                        this.loading = false
                        var vm = this;
                        vm.$refs.chamaSnackbar.snack("#EF5350","Usuário e Senha inválidos, corrija e tente novamente!","ERRO")
                    })
                } else {
                    this.loading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos de Login e Senha!","ATENÇÃO")
                }
            },

            /* signup() {
                if ((this.user.email != null) || (this.user.username != null) || (this.user.password != null)) {
                    this.$http.post('Usuarios', this.user)
                    .then(() => {
                        this.user = {}
                        this.showSignup = false
                    })
                    .catch(() => {
                    })
                } else {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("warning","Preencha os campos obrigatórios! ")
                }
            }, */

            Sair() {
                this.$store.dispatch('Sair')
            },

            /* async contabilizaAcesso() {
                if (this.userId != '') {
                    this.countAccess = parseInt(this.countAccess) + 1
                    await axios.patch(`${baseApiUrl}Usuarios/${this.userId}?access_token=${this.token}`, {"ultimoAcesso" : new Date().toLocaleString(), "countAccesses" : this.countAccess} )
                }
            }, */

            async VerficiaAdmin() {
                if (this.userId != '') {
                    await axios.get(`${baseApiUrl}Usuarios/${this.userId}?access_token=${this.token}`)
                    .then(res => {
                        if (res.data.tipo === "GERENTE" || res.data.tipo === "ADMIN" || res.data.tipo === "KIDS"  || res.data.tipo === 'LIDER'  || res.data.tipo === 'BACKUP'  || res.data.tipo === "EVENTO" && res.data.ativo === true) {
                            sessionStorage.setItem('accToken', this.token)
                            this.$store.dispatch('Logar', this.token)
                            this.userPemission = res.data.tipo
                            this.user.username = res.data.nome
                            this.userObj = res.data
                            if (res.data.countAccesses == null)
                                this.countAccess = 0
                            else
                                this.countAccess = res.data.countAccesses
                            sessionStorage.setItem(userKey, JSON.stringify(this.userPemission))
                            sessionStorage.setItem('userPermission', this.userPemission)
                            sessionStorage.setItem('userName', this.user.username)
                            sessionStorage.setItem('user', JSON.stringify(res.data))
                            this.$store.dispatch('SetUser')
                            this.$store.dispatch('Permission')
                            this.$store.dispatch('SetUserName')
                            this.$router.push({ path: '/home' })
                            this.verificaCompany()
                            //this.contabilizaAcesso()
                        } else {
                            this.loading = false
                            var vm = this;
                            vm.$refs.chamaSnackbar.snack("warning","Usuário inativo ou sem permissão de acesso!")
                        }
                    })
                    .catch(() => {
                    })
                }
            },

            verificaCompany() {
                // Igrejas criadas via cadastro público não possuem empresa vinculada.
                // Evita gravar "undefined" no storage (quebra o JSON.parse no store).
                if (!this.userObj.empresaId) {
                    sessionStorage.setItem('company', JSON.stringify({}))
                    this.$store.dispatch('SetCompany')
                    this.loading = false
                    return
                }
                axios.get(`${baseApiUrl}Empresas?filter[where][id]=${this.userObj.empresaId}&access_token=${this.token}`)
                .then(res => {
                    sessionStorage.setItem('company', JSON.stringify(res.data && res.data[0] ? res.data[0] : {}))
                    this.$store.dispatch('SetCompany')
                    this.loading = false
                })
                .catch(() => {
                    sessionStorage.setItem('company', JSON.stringify({}))
                    this.$store.dispatch('SetCompany')
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,600&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

.lg-wrap {
  min-height: 100vh; width: 100%; display: flex; align-items: center; justify-content: center;
  padding: 24px; background: #FBF7F5; font-family: 'Plus Jakarta Sans', sans-serif;
}
.lg-card {
  width: 100%; max-width: 940px; display: grid; grid-template-columns: 1fr 1fr;
  background: #fff; border-radius: 20px; overflow: hidden; box-shadow: 0 30px 60px rgba(0,37,62,.22);
}

/* painel de marca */
.lg-brand {
  position: relative; display: flex; align-items: center; justify-content: center;
  background: linear-gradient(150deg, #00493F 0%, #00695C 55%, #01B094 100%); overflow: hidden;
}
.lg-brand__glow {
  position: absolute; width: 460px; height: 460px; right: -150px; top: -140px; border-radius: 50%;
  background: radial-gradient(circle, rgba(91,193,163,.45), transparent 62%);
}
.lg-brand__content { position: relative; z-index: 1; text-align: center; padding: 44px 36px; width: 100%; }
.lg-brand__logo { width: 190px; max-width: 74%; display: block; margin: 0 auto 18px; }
.lg-brand__art { width: 100%; max-width: 320px; display: block; margin: 0 auto 18px; }
.lg-brand__tag { color: rgba(255,255,255,.92); font-size: 1.02rem; margin: 0; }

/* formulário */
.lg-form { padding: 48px 46px; display: flex; flex-direction: column; justify-content: center; }
.lg-lock {
  width: 62px; height: 62px; border-radius: 50%; background: #E9F6F0;
  display: grid; place-items: center; margin: 0 auto 16px;
}
.lg-lock .v-icon { font-size: 30px; }
.lg-title { font-family: 'Fraunces', Georgia, serif; font-weight: 600; font-size: 2rem; color: #22201E; text-align: center; margin: 0 0 4px; }
.lg-sub { text-align: center; color: #7a726d; font-size: .95rem; margin: 0 0 26px; }

.lg-label { display: block; font-weight: 600; color: #22201E; font-size: .88rem; margin: 0 0 8px; }
.lg-form >>> .v-text-field--outlined .v-input__slot { border-radius: 12px; }
.lg-btn { border-radius: 999px !important; text-transform: none !important; letter-spacing: 0 !important; font-weight: 600 !important; height: 48px !important; margin-top: 4px; }

.lg-foot { text-align: center; margin: 24px 0 0; color: #7a726d; font-size: .9rem; }
.lg-link { color: #00695C; font-weight: 600; text-decoration: none; }
.lg-link:hover { text-decoration: underline; }

@media (max-width: 760px) {
  .lg-card { grid-template-columns: 1fr; max-width: 440px; }
  .lg-brand { min-height: 200px; }
  .lg-brand__logo { width: 150px; margin-bottom: 10px; }
  .lg-brand__art { max-width: 200px; margin-bottom: 10px; }
  .lg-form { padding: 34px 26px; }
}

/* ===== modo escuro ===== */
.theme--dark .lg-wrap { background: #1a1519; }
.theme--dark .lg-card { background: #211a1f; box-shadow: 0 30px 60px rgba(0,0,0,.5); }
.theme--dark .lg-title { color: #eaf2ef; }
.theme--dark .lg-sub { color: rgba(255,255,255,.65); }
.theme--dark .lg-label { color: #eaf2ef; }
.theme--dark .lg-lock { background: rgba(1,176,148,.15); }
.theme--dark .lg-foot { color: rgba(255,255,255,.65); }
</style>
